import errorModule from 'src/js/modules/error';
import { batch } from 'react-redux';
import checkoutServiceClient from 'src/js/modules/checkoutservice-client/service-client';
import { snakeCaseObjectToCamelCase } from '../../../utils/convert-case';
import statusNames from '../constants/status-names';
import status from '../../status';
import actions from '../actions';
import resolveHttpClientError from '../../../common/helpers/resolve-http-client-error';

const fetchBillingProfiles = () => async (dispatch) => {
  const cosClient = checkoutServiceClient.get();
  let responseData;

  dispatch(status.actions.setStatus(statusNames.BILLING_PROFILES, status.constants.LOADING));

  try {
    const response = await cosClient.billingProfiles.get();
    responseData = snakeCaseObjectToCamelCase(response);

    batch(() => {
      dispatch(actions.setBillingProfiles(responseData));
      dispatch(status.actions.setStatus(statusNames.BILLING_PROFILES, status.constants.SUCCEEDED));
    });
  } catch (e) {
    errorModule.operations.catchError(e);
    const error = resolveHttpClientError(e);

    console.error(error);
    dispatch(status.actions.setStatus(statusNames.BILLING_PROFILES, status.constants.FAILED));

    throw error;
  }

  return responseData;
};

export default fetchBillingProfiles;
